export function formatUnixTimestamp(timestamp: number): string {
  const date = new Date(timestamp)

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
//   const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}`
}

export function formatCurrency(amount: number | string): string {
  const lang = localStorage.getItem('lang')
  let num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) num = 0;
  const formatted = num.toFixed(2);
  if (lang === 'pt') {
    return formatted.replace('.', ',');
  } else if (lang === 'en') {
    return formatted;
  }
  return formatted;
}

export function formatWithCommas(value: number | string): string {
  return Number(value).toLocaleString('en-US');
}

export function dayFormat(dateStr: string, addDays: number): string {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '00-00';

  date.setDate(date.getDate() + addDays);
  const formatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
  });

  const parts = formatter.formatToParts(date);
  const month = parts.find(p => p.type === 'month')?.value;
  const day = parts.find(p => p.type === 'day')?.value;

  return `${month}-${day}`;
}

export function checkDate(dateStr: string): number {
  const inputDate = new Date(dateStr);
  if (isNaN(inputDate.getTime())) return -2; // invalid date

  const today = new Date();

  // Clear time part for accurate comparison
  const input = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
  const current = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  if (input.getTime() === current.getTime()) {
    return 0; // today
  } else if (input < current) {
    return -1; // past
  } else {
    return 1; // future
  }
}
export function getTodayData(data: any[]): any | undefined {
  if(data){
    const today = new Date().toISOString().slice(0, 10) // 'YYYY-MM-DD'

    return data.find(item => item.createTime.startsWith(today))
  }else{
    return null
  }
  
}

export function sumArray(array: number[]): number {
  return array.reduce((total, num) => total + num, 0)
}

export function convertStringToArray(jsonString: string): { date: string; amount: number }[] {
  if(jsonString){
  try {
    const parsed = JSON.parse(jsonString);
    if (Array.isArray(parsed)) {
      return parsed;
    } else {
      throw new Error("Parsed data is not an array");
    }
  } catch (error) {
    console.error("Invalid JSON string:", error);
    return [];
  }
  }else{
    return []
  }
}

export function getDefaultRewards(days?: number): any {
  const totalDays = days ?? 11;
  const rewards = [];
  const today = new Date();

  for (let i = 0; i < totalDays; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);

    const formattedDate = date.toISOString().split("T")[0];
    rewards.push({
      date: formattedDate,
      amount: "0.0"
    });
  }

  return rewards;
}


export function sumAmounts(data?: { date: string; amount: string }[]): number {
  if (!Array.isArray(data)) return 0;

  return data.reduce((total, item) => {
    const num = parseFloat(item.amount);
    return total + (isNaN(num) ? 0 : num);
  }, 0);
}

// PWA set popup show time duration 
export function getNextTimeSlot(durationSeconds: number, startTime: Date = new Date()): string | null {
  const now: Date = new Date(startTime);

  now.setSeconds(0, 0); // normalize

  // calculate next slot
  const next: Date = new Date(now.getTime() + durationSeconds * 1000);

  // if still same day, return formatted string
  if (next.getDate() === now.getDate()) {
    return formatDateTime(next);
  }

  // if it passes midnight, return null
  return null;

  function formatDateTime(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}.${min}`;
  }
}

export function isPastTime(timeStr: string): boolean {
  const [datePart, timePart] = timeStr.split(" ");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute] = timePart.split(".").map(Number);

  const givenTime = new Date(year, month - 1, day, hour, minute);
  const now = new Date();

  return givenTime.getTime() < now.getTime();
}

export function generate30DaysArray(source: any[]): { date: string; amount: string }[] {
  const today = new Date();
  const result: { date: string; amount: string }[] = [];

  // Convert source array into a map for quick lookup
  const sourceMap = new Map(source.map(item => [item.date, item.amount]));

  for (let i = 0; i < 30; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);

    const dateStr = d.toISOString().split("T")[0]; // format YYYY-MM-DD

    result.push({
      date: dateStr,
      amount: sourceMap.get(dateStr) ?? "0.0",
    });
  }

  return result;
}

export function getNextDayDate(dayNumber: number): string {
  if (dayNumber < 0 || dayNumber > 6) {
    throw new Error("Day number must be between 0 (Mon=0 and Sun=6).");
  }

  const today = new Date(); // current date
  const jsDay = today.getDay(); // 0=Sun .. 6=Sat

  // Convert JS day to your mapping (0=Mon ... 6=Sun)
  const customDay = (jsDay + 6) % 7;

  let daysToAdd = dayNumber - customDay;
  if (daysToAdd < 0) {
    daysToAdd += 7; // move to next week if target already passed
  }

  const result = new Date(today);
  result.setDate(today.getDate() + daysToAdd);

  // Format YYYY-MM-DD
  const year = result.getFullYear();
  const month = String(result.getMonth() + 1).padStart(2, "0");
  const date = String(result.getDate()).padStart(2, "0");

  return `${year}-${month}-${date}`;
}
export function toZigZagWithFlags<T extends object>(
    arr: T[],
    cols: number
): (T & { side: 'left' | 'right'; isCorner: boolean; turnDown: boolean; isLast: boolean })[] {
    const result: (T & { side: 'left' | 'right'; isCorner: boolean; turnDown: boolean; isLast: boolean })[] = [];

    const lastId = arr[arr.length - 1]; // keep reference to original last item

    for (let i = 0; i < arr.length; i += cols) {
        let row = arr.slice(i, i + cols);
        const rowIndex = Math.floor(i / cols);
        const side = rowIndex % 2 === 0 ? "left" : "right";

        if (side === "right") {
            row = row.reverse();
        }

        row.forEach((item, j) => {
            const isCorner = j === 0 || j === row.length - 1;

            let turnDown = false;
            if (side === "left" && j === row.length - 1) turnDown = true;
            if (side === "right" && j === 0) turnDown = true;

            const isLast = item === lastId; // check against original last object

            result.push({ ...item, side, isCorner, turnDown, isLast });
        });
    }

    return result;
}

export function toZigZagWithFlagsAdvance<T extends Record<string, any>>(arr: T[], cols: number) {
  const result: (T & {
    side: 'left' | 'right';
    isCorner: boolean;
    turnDown: boolean;
    isLast: boolean;
    isNullObject: boolean;
    displayIndex: number; // added display position
  })[] = [];

  if (!Array.isArray(arr) || cols <= 0) return result;

  const lastIndex = arr.length - 1;
  const rows = Math.ceil(arr.length / cols);

  for (let rowIndex = 0; rowIndex < rows; rowIndex++) {
    const start = rowIndex * cols;
    const end = Math.min(start + cols, arr.length);
    const items = arr.slice(start, end);
    const n = items.length;
    const side: 'left' | 'right' = rowIndex % 2 === 0 ? 'left' : 'right';

    // fixed positions for row
    const positions: (T | null)[] = new Array(cols).fill(null);

    if (side === 'left') {
      for (let k = 0; k < n; k++) positions[k] = items[k];
    } else {
      for (let k = 0; k < n; k++) positions[cols - n + k] = items[n - 1 - k];
    }

    const firstOccupied = positions.findIndex(p => p !== null);
    const lastOccupied = positions.length - 1 - [...positions].reverse().findIndex(p => p !== null);

    for (let col = 0; col < cols; col++) {
      const item = positions[col];

      if (item == null) {
        result.push({
          ...(Object.create(null) as T),
          side,
          isCorner: false,
          turnDown: false,
          isLast: false,
          isNullObject: true,
          displayIndex: col
        });
      } else {
        // natural index in original array
        let naturalIdxWithinRow: number;
        if (side === 'left') {
          naturalIdxWithinRow = col;
        } else {
          const offset = cols - n;
          naturalIdxWithinRow = n - 1 - (col - offset);
        }
        const naturalIndex = start + naturalIdxWithinRow;

        // turnDown only for the one corner that drops the snake
        let turnDown = false;
        if (rowIndex < rows - 1) {
          turnDown = side === 'left' ? col === lastOccupied : col === firstOccupied;
        }

        // corner = turning point only
        const isCorner = side === 'left' ? col === lastOccupied : col === firstOccupied;

        const isLast = naturalIndex === lastIndex;

        result.push({
          ...item,
          side,
          isCorner,
          turnDown,
          isLast,
          isNullObject: false,
          displayIndex: col
        });
      }
    }
  }

  return result;
}






